module.exports = __webpack_public_path__ + "img/Defagenciesbutton.41df6645.png";